import {
    CreateParams,
    DataProvider,
    DeleteParams,
    GetListParams,
    GetListResult,
    GetOneParams,
    GetOneResult,
    UpdateParams
} from 'react-admin';
import { adminUsersProxy } from './apiGateway';

export type AdminUserRole =
    | 'manager-admin'
    | 'moderator'
    | 'moderator-admin'
    | 'expert'
    | 'expert-admin'
    | 'expert-outstaff'
    | 'expert-admin-outstaff'
    | 'developer';

export interface AdminUser {
    id: string;
    login: string;
    fullName: string;
    role: AdminUserRole;
    isActive: boolean;
    lastLoginAt: string | null;
    createdAt?: string;
    updatedAt?: string;
}

interface AdminUsersListResponse {
    data: AdminUser[];
    total?: number;
}

interface AdminUserResponse {
    data: AdminUser;
}

export const adminUsersDataProvider = {
    getList: async (_resource: string, _params: GetListParams): Promise<GetListResult<AdminUser>> => {
        const payload: AdminUsersListResponse = await adminUsersProxy.getList();
        const data = payload?.data ?? [];
        return {
            data,
            total: payload?.total ?? data.length
        };
    },
    getOne: async (_resource: string, params: GetOneParams): Promise<GetOneResult<AdminUser>> => {
        const payload: AdminUserResponse = await adminUsersProxy.getOne(String(params.id));
        return { data: payload.data };
    },
    create: async (_resource: string, params: CreateParams<AdminUser & { password: string }>) => {
        const payload: AdminUserResponse = await adminUsersProxy.create({
            login: params.data.login,
            fullName: params.data.fullName,
            role: params.data.role,
            password: params.data.password,
            isActive: params.data.isActive ?? true
        });
        return { data: payload.data };
    },
    update: async (_resource: string, params: UpdateParams<AdminUser & { password?: string }>) => {
        const payload: AdminUserResponse = await adminUsersProxy.update(String(params.id), {
            login: params.data.login,
            fullName: params.data.fullName,
            role: params.data.role,
            password: params.data.password,
            isActive: params.data.isActive
        });
        return { data: payload.data };
    },
    delete: async (_resource: string, params: DeleteParams<AdminUser>) => {
        const payload: AdminUserResponse = await adminUsersProxy.delete(String(params.id));
        return { data: payload.data };
    }
} as DataProvider;
